/** Routes du module — propriétaire : Agent A4 — Sécurité (inscription, vérification e-mail, mot de passe, invitation). Contrat : exporter `routesAuthPublic`. */
import type { RouteObject } from 'react-router';
import { PageDevenirClient, PageInvitation, PageMotDePasseOublie, PageReinitialiserMotDePasse, PageStatutInscription, PageVerificationEmail } from './Inscription';

export const routesAuthPublic: RouteObject[] = [
  { path: 'devenir-client', element: <PageDevenirClient /> },
  // Liens envoyés par les e-mails simulés (auth.ts) : /verification-email/:jeton, /mot-de-passe/reinitialiser/:jeton, /invitation/:jeton
  { path: 'verification-email/:jeton', element: <PageVerificationEmail /> },
  { path: 'verifier-email', element: <PageVerificationEmail /> },
  { path: 'statut-inscription', element: <PageStatutInscription /> },
  { path: 'mot-de-passe-oublie', element: <PageMotDePasseOublie /> },
  { path: 'mot-de-passe/reinitialiser/:jeton', element: <PageReinitialiserMotDePasse /> },
  { path: 'reinitialiser-mot-de-passe', element: <PageReinitialiserMotDePasse /> },
  { path: 'invitation/:jeton', element: <PageInvitation /> },
  { path: 'invitation', element: <PageInvitation /> },
];
